
import React, {Component} from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from "react-google-recaptcha";
import validator from "validator";


const styles = {
    disabledButton: {
        color: 'lightgray',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    enabledButton: {
        cursor: 'pointer',
        pointerEvents: 'all'
    },
};

class Contacts extends Component {

    recaptchatoken = '';

    constructor(props) {
        super(props);
        this.state = { name: "", email: "", message: "", recaptchaOk: false };
    }

    sendEmail(e) {
        e.preventDefault();
        const templateParams = Object.fromEntries(new FormData(e.target));

        emailjs
          .send('service_jei87fg', 'template_95oaugi', templateParams, {
              publicKey: '7zIvDVstRAFkB9668',
          })
          .then(
            () => {
              console.log('SUCCESS!');
              alert("Thank you for your message");
            },
            (error) => {
              console.log('FAILED...', error);
            },
        );
    };

    onSubmit = async (e) => {
        try {
            e.preventDefault();
            await this.sendRecaptcha(this.recaptchatoken);
            this.sendEmail(e);
        } catch (e) {
            console.error('onSubmit:' + e.message);
        }
    }

    async sendRecaptcha(recaptchatoken) {
        try {
            const response = await fetch('https://alfheim.hemdahl.com/api/authentication/webrecaptcha', {
                method: 'POST',
                body: JSON.stringify({
                    recaptchatoken,
                    expectedAction: 'SendWebMessage',
                }),
                headers: {
                    'Content-type': 'application/json',
                },
            });
            const responseObj = await response.json();
            console.log('responseObj:', responseObj);
        } catch(err) {
            console.error(err.message);
        }
    }

    handleChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    onRecaptchaChange = e => {
        this.recaptchatoken = e;
        this.setState({recaptchaOk: true})
    }

    isFormValid() {
        return this.state.recaptchaOk && this.state.name.trim() !== "" && this.state.message.trim() !== "" && validator.isEmail(this.state.email);
    }

    render(){
        const recaptchaRef = React.createRef();
        return(
            <section className="contact_info_area sec_pad bg_color">
                <div className="container">
                    <div className="row">
                        <div className="contact_form col-lg-9">
                            <h2 className="f_p f_size_22 t_color3 f_600 l_height28 mb_40">Leave a Message</h2>
                             <form onSubmit={this.onSubmit} className="contact_form_box" method="post" id="contactForm">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group text_box">
                                            <input type="text" id="name" name="name" placeholder="Your Name" onChange={this.handleChange}/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group text_box">
                                            <input type="text" name="email" id="email" placeholder="Your Email" onChange={this.handleChange}/>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group text_box">
                                            <input type="text" id="subject" name="subject" placeholder="Subject" onChange={this.handleChange}/>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group text_box">
                                            <textarea onChange={this.handleChange} name="message" id="message" cols="30" rows="10" placeholder="Enter Your Message . . ."></textarea>
                                        </div>
                                    </div>
                                </div>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ldo2GksAAAAAJg_eN1TEVfrIH6mgs79i8RtqCXM"
                                    onChange={this.onRecaptchaChange}
                                />
                                <button type="submit" style={this.isFormValid() ? styles.enabledButton: styles.disabledButton }  className="mt-4 btn_get new_btn" disabled={!this.isFormValid()}>Send Message</button>
                            </form>
                            <div id="success">Your message succesfully sent!</div>
                            <div id="error">Opps! There is something wrong. Please try again</div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Contacts;
